_getPmSectionSingle